import React from 'react';
import 'material-icons/iconfont/material-icons.css';
import { Routes } from 'react-router-dom';
import styled from 'styled-components';

import AdmRoutes from './Rotas/AdmRoutes';
import FornecedoresRoutes from './Rotas/FornecedoresRoutes';
import HomeRoutes from './Rotas/HomeRoutes';
import LogisticaRoutes from './Rotas/Logistica';
import MaisOpcoesRoutes from './Rotas/MaisOpcoesRoutes';
import MeusDadosRoutes from './Rotas/MeusDadosRoutes';
import ProcessosAquisitivosRoutes from './Rotas/ProcessosAquisitivos';
import ProcessosJuridicosRoutes from './Rotas/ProcessosJuridicos';
import ProdutosDAFRoutes from './Rotas/ProdutosDAFRoutes';
import ProgramacaoRoutes from './Rotas/Programacao';
import SESRoutes from './Rotas/SES';
import Breadcrumbs from '../../../components/BreadCrumb';
import Sidebar from '../../../components/Sidebar';
import { hasVinculo } from '../../../modules/contexts/Auth/RequireAuth';
import {
  isAdmin,
  useNomeCompleto,
} from '../../../modules/contexts/userContexts';

const Container = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  min-height: 100vh;
`;

const WorkspaceContainer = styled.div`
  display: grid;
  grid-template-rows: 5vh 95vh;
`;

const Workspace = styled.div`
  background-color: ${({ theme }) => theme.colors.fundo};
  height: calc(100vh - 5vh);
  overflow-x: hidden;
  display: grid;
  grid-template-rows: 5% 90% 5%;
`;

const AppDAF: React.FC = () => {
  const { papel } = useNomeCompleto();
  const isUserAdmin = isAdmin(papel);

  const allowedOnlyMeusDados = !hasVinculo();

  return (
    <Container>
      <Sidebar />
      <WorkspaceContainer>
        <Breadcrumbs />
        <Workspace>
          <Routes>
            {allowedOnlyMeusDados ? (
              <>{MeusDadosRoutes()}</>
            ) : (
              <>
                {HomeRoutes()}
                {MeusDadosRoutes()}
                {MaisOpcoesRoutes()}
                {ProdutosDAFRoutes()}
                {SESRoutes()}
                {FornecedoresRoutes()}
                {ProcessosJuridicosRoutes()}
                {ProcessosAquisitivosRoutes()}
                {LogisticaRoutes()}
                {ProgramacaoRoutes()}
                {isUserAdmin && AdmRoutes()}
              </>
            )}
          </Routes>
        </Workspace>
      </WorkspaceContainer>
    </Container>
  );
};

export default AppDAF;
